import { j as r } from "../../jsx-runtime-BwWtxLpl.js";
import l from "classnames";
import e from "prop-types";
import k, { useMemo as v } from "react";
const P = (m) => {
  const {
    circle: s = !1,
    isIndeterminate: t = !1,
    className: C = "",
    value: o = t ? 25 : 0,
    error: i = !1,
    hideLabel: c = !1,
    labelComponent: n = null,
    processStateLabel: b = "Processing...",
    resultStateLabel: d = "Completed",
    labelPosition: f = "default",
    showLabel: g,
    ...u
  } = m, h = l(
    {
      "motif-progress-bar-wrapper": !0,
      "motif-progress-bar-wrapper-circle": s,
      [C]: !0
    },
    !s && !n && `motif-progress-bar-label-${f}`
  ), x = l({
    "motif-progress-bar": !0,
    "motif-progress-bar-circle": s,
    "motif-progress-bar-indeterminate": t,
    "motif-progress-error": i
  }), L = () => {
    const w = l({
      "motif-progress": !0
    });
    return /* @__PURE__ */ r.jsx("div", { className: w, style: t ? null : { width: `${o}%` } });
  };
  let a;
  o >= 100 ? a = "360" : o <= -1 ? a = "180" : a = `${180 - o / 100 * 180}`;
  const j = v(
    () => /* @__PURE__ */ r.jsx(k.Fragment, { children: /* @__PURE__ */ r.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: "64", height: "64", viewBox: "0 0 64 64", fill: "none", children: [
      /* @__PURE__ */ r.jsx(
        "path",
        {
          d: "M32 3C35.8083 3 39.5794 3.75011 43.0978 5.20749C46.6163 6.66488 49.8132 8.80101 52.5061 11.4939C55.199 14.1868 57.3351 17.3837 58.7925 20.9022C60.2499 24.4206 61 28.1917 61 32C61 35.8083 60.2499 39.5794 58.7925 43.0978C57.3351 46.6163 55.199 49.8132 52.5061 52.5061C49.8132 55.199 46.6163 57.3351 43.0978 58.7925C39.5794 60.2499 35.8083 61 32 61C28.1917 61 24.4206 60.2499 20.9022 58.7925C17.3837 57.3351 14.1868 55.199 11.4939 52.5061C8.801 49.8132 6.66487 46.6163 5.20749 43.0978C3.7501 39.5794 3 35.8083 3 32C3 28.1917 3.75011 24.4206 5.2075 20.9022C6.66489 17.3837 8.80101 14.1868 11.4939 11.4939C14.1868 8.80099 17.3838 6.66487 20.9022 5.20749C24.4206 3.7501 28.1917 3 32 3L32 3Z",
          stroke: "#E6E6E9",
          strokeWidth: "6",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ r.jsx(
        "path",
        {
          d: "M32 3C35.8083 3 39.5794 3.75011 43.0978 5.20749C46.6163 6.66488 49.8132 8.80101 52.5061 11.4939C55.199 14.1868 57.3351 17.3837 58.7925 20.9022C60.2499 24.4206 61 28.1917 61 32C61 35.8083 60.2499 39.5794 58.7925 43.0978C57.3351 46.6163 55.199 49.8132 52.5061 52.5061C49.8132 55.199 46.6163 57.3351 43.0978 58.7925C39.5794 60.2499 35.8083 61 32 61C28.1917 61 24.4206 60.2499 20.9022 58.7925C17.3837 57.3351 14.1868 55.199 11.4939 52.5061C8.801 49.8132 6.66487 46.6163 5.20749 43.0978C3.7501 39.5794 3 35.8083 3 32C3 28.1917 3.75011 24.4206 5.2075 20.9022C6.66489 17.3837 8.80101 14.1868 11.4939 11.4939C14.1868 8.80099 17.3838 6.66487 20.9022 5.20749C24.4206 3.7501 28.1917 3 32 3L32 3Z",
          stroke: "#2E2E38",
          strokeWidth: "6",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeDasharray: 180,
          strokeDashoffset: a
        }
      )
    ] }) }),
    [o, i, t]
  ), p = t && !s ? b : `${i ? "" : `${o}%`}  ${s ? "" : d}`;
  return /* @__PURE__ */ r.jsxs("div", { className: h, role: "progressbar", title: p, "data-motif-progress-bar": !0, children: [
    n || /* @__PURE__ */ r.jsx(
      "span",
      {
        "aria-live": "polite",
        className: l({
          "motif-progress-bar-label": !0,
          "motif-progress-bar-label-hidden": c
        }),
        children: p
      }
    ),
    /* @__PURE__ */ r.jsx("div", { ...u, showlabel: g, className: x, children: s ? j : L() })
  ] });
};
P.propTypes = {
  className: e.string,
  value: e.number,
  circle: e.bool,
  error: e.bool,
  isIndeterminate: e.bool,
  hideLabel: e.bool,
  processStateLabel: e.string,
  resultStateLabel: e.string,
  labelComponent: e.oneOfType([e.element, e.elementType]),
  labelPosition: e.oneOf(["top", "right", "bottom", "default"])
};
export {
  P as MotifProgressBar
};
